import {Copy, Package} from "lucide-react";
import {Badge} from "../../../basic/badge";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {VwpLicenseRead} from "../../../../store/generated/api";
import {getTeamDisplayName} from "../../../../utils/teamUtils";
import {toast} from "sonner";

interface LicenseDetailsProps {
    selectedLicense: VwpLicenseRead;
}

export function LicenseDetails({selectedLicense}: LicenseDetailsProps) {
    const {t} = useTranslationWithKeys();

    const handleCopyLicenseId = () => {
        if (selectedLicense.id) {
            navigator.clipboard.writeText(selectedLicense.id);
            toast.success(t('admin.licenses.editLicense.licenseIdCopied'));
        }
    };

    const handleCopyTeamId = () => {
        if (selectedLicense.team?.id) {
            navigator.clipboard.writeText(selectedLicense.team.id);
            toast.success(t('admin.licenses.editLicense.teamIdCopied'));
        }
    };

    return (
        <div className="flex items-center gap-3 pb-4 border-b">
            <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
                <Package className="h-6 w-6 text-primary"/>
            </div>
            <div className="flex items-center gap-2">
                <div>
                    <div className="flex items-center gap-2">
                        <p className="text-muted-foreground">{t('admin.licenses.editLicense.licenseId')}: {selectedLicense.id}</p>
                        <button
                            onClick={handleCopyLicenseId}
                            className="text-muted-foreground hover:text-foreground transition-colors"
                            title={t('common.copy')}
                        >
                            <Copy className="h-4 w-4"/>
                        </button>
                    </div>
                    <p className="text-muted-foreground">
                        {t('admin.licenses.editLicense.team')}: {selectedLicense.team ? (
                        <span className="flex items-center gap-2">
                                {getTeamDisplayName({
                                    teamName: selectedLicense.team.name,
                                    firstName: selectedLicense.team.adminName?.split(' ')[0],
                                    lastName: selectedLicense.team.adminName?.split(' ').slice(1).join(' ')
                                }) ?? t('common.noTeam')}
                            {selectedLicense.team.id && (
                                <span className="flex items-center gap-1 text-muted-foreground/60">
                                    ({selectedLicense.team.id}
                                    <button
                                        onClick={handleCopyTeamId}
                                        className="hover:text-foreground transition-colors"
                                        title={t('common.copy')}
                                    >
                                        <Copy className="h-3.5 w-3.5"/>
                                    </button>
                                </span>
                            )}
                            </span>
                    ) : 'N/A'}
                    </p>
                </div>
                {selectedLicense.supportLevel === 'SMA' && (
                    <Badge variant="secondary" className="text-xs">
                        {t('licenses.sma')}
                    </Badge>
                )}
                {selectedLicense.supportLevel === 'SMA_PLUS' && (
                    <Badge variant="secondary" className="text-xs">
                        {t('licenses.smaPlus')}
                    </Badge>
                )}
            </div>
        </div>
    );
}